/* The Eight Days of Christmas · page behaviour.
   Hero CTA, collapsible Today panel with its swinging door, the eight-door
   grid (hinge animation, glow, list view, progress stars), the modal with
   prev/next and future-day notify, email capture, the offer modules, snow,
   and the staff preview switcher. The clock and pure state helpers live in
   ojx-clock.js (window.OJXClock). Vanilla JS, no dependencies. */
(function () {
  'use strict';
  if (window.__ojxInit) return;
  window.__ojxInit = true;

  var HINGE_MS = 980, PANEL_MS = 800, COPIED_MS = 1600;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function storage(kind) {
    var s = null;
    try { s = window[kind]; s.setItem('ojx:test', '1'); s.removeItem('ojx:test'); } catch (e) { s = null; }
    return {
      getItem: function (k) { try { return s ? s.getItem(k) : null; } catch (e) { return null; } },
      setItem: function (k, v) { try { if (s) s.setItem(k, v); } catch (e) {} },
      removeItem: function (k) { try { if (s) s.removeItem(k); } catch (e) {} }
    };
  }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      var v = attrs[k];
      if (v === null || v === undefined || v === false) return;
      if (k === 'class') node.className = v;
      else if (k === 'text') node.textContent = v;
      else if (k === 'html') node.innerHTML = v;
      else if (k === 'hidden') node.hidden = !!v;
      else if (k === 'disabled') node.disabled = !!v;
      else node.setAttribute(k, v === true ? '' : v);
    });
    (children || []).forEach(function (c) { if (c) node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return node;
  }
  var ARROW = '<svg class="ojx-arrow" viewBox="0 0 24 10" aria-hidden="true"><path d="M0 5h22M18 1l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1"/></svg>';
  function arrow() { var span = el('span', { html: ARROW }); return span.firstChild; }

  ready(function () {
    Array.prototype.slice.call(document.querySelectorAll('[data-ojx-root]')).forEach(function (root) {
      try { init(root); } catch (e) { if (window.console) console.error('[eight-days]', e); }
    });
  });

  function init(root) {
    var Clock = window.OJXClock;
    var cfgEl = root.querySelector('[data-ojx-config]');
    if (!Clock || !cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var $ = function (sel, scope) { return (scope || root).querySelector(sel); };
    var $$ = function (sel, scope) { return Array.prototype.slice.call((scope || root).querySelectorAll(sel)); };
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var session = storage('sessionStorage'), local = storage('localStorage');
    var TOTAL = cfg.totalDays || 8;

    /* ---------- services (typed at the top, stubbed where no backend exists) ---------- */
    var email = session.getItem('ojx:email') || '';
    function link(url) {
      if (!url) return '#';
      var rootUrl = (cfg.rootUrl || '/').replace(/\/$/, '');
      if (rootUrl && url.charAt(0) === '/' && url.indexOf(rootUrl + '/') !== 0 && url !== rootUrl) return rootUrl + url;
      return url;
    }
    function analytics(name, props) {
      var payload = props || {};
      try { var kl = window.klaviyo || window._learnq; if (kl && typeof kl.push === 'function') kl.push(['track', name, payload]); } catch (e) {}
      try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'ojx_' + name.toLowerCase().replace(/[^a-z0-9]+/g, '_') }, payload)); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('ojx:' + name, { detail: payload })); } catch (e) {}
    }
    function klaviyoPost(path, body) {
      var key = cfg.klaviyo && cfg.klaviyo.publicKey;
      if (!key || !window.fetch) return Promise.resolve({ stubbed: true });
      return fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + encodeURIComponent(key), {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/json', revision: cfg.klaviyo.revision || '2026-04-15' },
        body: JSON.stringify(body)
      }).then(function (res) { if (!res.ok && res.status !== 202) throw new Error('klaviyo ' + res.status); return { ok: true }; });
    }
    function klaviyoSubscribe(address, source, properties) {
      var attrs = { email: address, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
      if (properties) attrs.properties = properties;
      var body = { data: { type: 'subscription', attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: attrs } } } } };
      if (cfg.klaviyo && cfg.klaviyo.listId) body.data.relationships = { list: { data: { type: 'list', id: cfg.klaviyo.listId } } };
      try { var kl = window.klaviyo || window._learnq; if (kl && typeof kl.push === 'function') kl.push(['identify', { $email: address }]); } catch (e) {}
      return klaviyoPost('subscriptions', body);
    }
    function klaviyoEvent(name, properties) {
      analytics(name, properties);
      if (!email) return Promise.resolve({ stubbed: true });
      return klaviyoPost('events', { data: { type: 'event', attributes: {
        properties: properties || {},
        metric: { data: { type: 'metric', attributes: { name: name } } },
        profile: { data: { type: 'profile', attributes: { email: email } } }
      } } });
    }
    var services = {
      /* Newsletter capture in the coral band. */
      subscribe: function (address) {
        email = address; session.setItem('ojx:email', address);
        analytics('Eight Days of Christmas Signup', { source: 'band' });
        return klaviyoSubscribe(address, cfg.klaviyo.source, { eight_days_signup: true });
      },
      /* Per-day "Notify me" from a future door's modal. */
      notify: function (address, day) {
        email = address; session.setItem('ojx:email', address);
        analytics('Eight Days of Christmas Signup', { source: 'notify', day: day });
        return klaviyoSubscribe(address, cfg.klaviyo.source + ' · Notify Day ' + day, { eight_days_notify_day: day });
      },
      rsvp: function (day) { return klaviyoEvent('Eight Days of Christmas RSVP', { day: day }); },
      ballot: function (day) { return klaviyoEvent('Eight Days of Christmas Ballot Entry', { day: day }); },
      copyCode: function (code) {
        analytics('Eight Days of Christmas Code Copied', { code: code });
        try { if (navigator.clipboard) return navigator.clipboard.writeText(code); } catch (e) {}
        return Promise.resolve();
      },
      link: link
    };

    /* ---------- state ---------- */
    var today = resolve(location.search);
    var state = Clock.initialState();
    state.layout = local.getItem('ojx:layout') === 'list' ? 'list' : 'grid';
    state.subscribed = session.getItem('ojx:subscribed') === '1';
    try { state.notified = JSON.parse(session.getItem('ojx:notified') || '[]'); } catch (e) { state.notified = []; }
    restoreOpened();

    function resolve(search) {
      return Clock.resolveToday({
        startDate: cfg.startDate, rolloverHour: cfg.rolloverHour, timeZone: cfg.timeZone, totalDays: TOTAL,
        previewFlag: !!cfg.previewFlag, search: search, storage: session
      });
    }
    function restoreOpened() { state.doorOpened = !!today.index && session.getItem('ojx:opened:' + today.index) === '1'; }
    function set(patch) { Object.keys(patch).forEach(function (k) { state[k] = patch[k]; }); render(); }

    /* ---------- day view models ---------- */
    var days = [];
    function buildDays() {
      days = cfg.days.map(function (d, idx) {
        var n = idx + 1;
        var status = Clock.dayStatus(n, today);
        return {
          idx: idx, n: n, n2: pad2(n), d: d, cal: Clock.dayCalendar(cfg.startDate, n) || { dow: '', dowLong: '', date: '', dateShort: '' },
          kit: cfg.assets.kits[idx % cfg.assets.kits.length], imgs: cfg.assets.days[idx],
          icon: cfg.assets.icons[d.icon], status: status,
          isToday: status === 'today', isPast: status === 'past', isFuture: status === 'future'
        };
      });
    }
    function isOpen(day) { return day.isToday && (state.doorOpening || state.doorOpened); }
    function metaFor(day) {
      if (day.isPast) return 'Now closed.';
      if (day.isToday) return day.cal.dateShort + ' · ' + (isOpen(day) ? 'Open Today' : 'Ready To Open');
      return day.cal.dateShort + ' · Opens ' + day.cal.dowLong;
    }
    /* Future doors give nothing away: no title, no offer, just when they open. */
    function labelFor(day) {
      if (day.isFuture) return 'Day ' + day.n + ', opens ' + day.cal.dowLong + ' ' + day.cal.date;
      return 'Day ' + day.n + ', ' + day.d.title + ', ' + day.cal.dowLong + ' ' + day.cal.date + (day.isToday ? ', today' : ', opened');
    }
    function todayDay() { return today.index ? days[today.index - 1] : null; }

    /* ---------- elements ---------- */
    var heroCta = $('[data-ojx-hero-cta]'), heroLabel = $('[data-ojx-hero-cta-label]');
    var signup = $('[data-ojx-signup]'), signupInput = $('[data-ojx-signup-input]'), signupBtn = $('[data-ojx-signup-btn]');
    var signupDone = $('[data-ojx-signup-done]'), signupError = $('[data-ojx-signup-error]'), signupClosed = $('[data-ojx-signup-closed]');
    var panel = $('[data-ojx-today]'), panelCopy = $('[data-ojx-today-copy]'), pdoor = $('[data-ojx-pdoor]');
    var grid = $('[data-ojx-grid]'), list = $('[data-ojx-list]'), stars = $('[data-ojx-stars]');
    var modal = $('[data-ojx-modal]'), modalCard = $('[data-ojx-modal-card]'), modalMedia = $('[data-ojx-modal-media]'), modalBody = $('[data-ojx-modal-body]');
    var modalPrev = $('[data-ojx-modal-prev]'), modalNext = $('[data-ojx-modal-next]'), modalCounter = $('[data-ojx-modal-counter]');
    var prevLabel = $('[data-ojx-prev-label]'), nextLabel = $('[data-ojx-next-label]');
    var preview = $('[data-ojx-preview]');

    /* ---------- offer modules (shared by the panel and the modal) ---------- */
    var modules = []; // live module instances, updated on every render
    function buildModule(day, interactive, compact) {
      var d = day.d, node = null, update = function () {};
      if (d.module === 'code' && d.code) {
        var stateEl = el('span', { class: 'ojx-code__state', text: 'Copy' });
        var chip = el('button', { type: 'button', class: 'ojx-code' + (compact ? ' ojx-code--sm' : ''), 'aria-label': 'Copy code ' + d.code }, [
          el('span', { class: 'ojx-label', text: 'Code' }), el('span', { class: 'ojx-code__value', text: d.code }), stateEl
        ]);
        chip.addEventListener('click', function () { copyCode(d.code); });
        node = el('div', { class: 'ojx-mod ojx-mod--code' }, [chip]);
        if (d.was && d.now) node.appendChild(el('div', { class: 'ojx-mod__prices' }, [el('span', { class: 'ojx-mod__was', text: d.was }), el('span', { class: 'ojx-mod__now', text: d.now })]));
        if (d.note) node.appendChild(el('span', { class: 'ojx-mod__note', text: d.note }));
        update = function () {
          var copied = state.copied === d.code;
          chip.classList.toggle('is-copied', copied);
          stateEl.textContent = copied ? 'Copied' : 'Copy';
        };
      } else if (d.module === 'duo' && d.duo) {
        var tabs = d.duo.map(function (t) {
          var b = el('button', { type: 'button', class: 'ojx-duo__tab', text: t.short, 'aria-pressed': 'false', disabled: !interactive });
          b.addEventListener('click', function () { set({ duo: t.k }); });
          return b;
        });
        var cur = el('p', { class: 'ojx-duo__cur' });
        node = el('div', { class: 'ojx-mod' }, [el('div', { class: 'ojx-duo', role: 'group', 'aria-label': 'Choose your bottle' }, tabs), cur, d.duoNote ? el('p', { class: 'ojx-duo__note', text: d.duoNote }) : null]);
        update = function () {
          var sel = d.duo.filter(function (t) { return t.k === state.duo; })[0] || d.duo[0];
          tabs.forEach(function (b, i) { var on = d.duo[i].k === sel.k; b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          cur.textContent = sel.label + ', ' + sel.price;
        };
      } else if (d.module === 'bundle' && d.chips) {
        var chips = d.chips.map(function (label, i) {
          var b = el('button', { type: 'button', class: 'ojx-chip', text: label, 'aria-pressed': 'false', disabled: !interactive });
          b.addEventListener('click', function () { set({ picks: Clock.togglePick(state.picks, i, 3) }); });
          return b;
        });
        var hint = el('p', { class: 'ojx-bundle__hint' });
        node = el('div', { class: 'ojx-mod' }, [el('p', { class: 'ojx-label', text: d.chipsLabel || 'Choose Any Three' }), el('div', { class: 'ojx-chips' }, chips), hint]);
        update = function () {
          chips.forEach(function (b, i) { var on = state.picks.indexOf(i) >= 0; b.classList.toggle('is-picked', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          hint.textContent = Clock.bundleHint(state.picks.length, 3);
        };
      } else if (d.module === 'rsvp' && d.rsvpRows) {
        var done = el('p', { class: 'ojx-mod__done', role: 'status', hidden: true, text: d.rsvpDone || 'Your place is held.' });
        var btn = el('button', { type: 'button', class: 'ojx-btn2', text: d.rsvpLabel || 'Reserve a place' });
        var action = el('div', { class: 'ojx-mod__action', hidden: !interactive }, [btn]);
        btn.addEventListener('click', function () {
          btn.setAttribute('aria-busy', 'true');
          services.rsvp(day.n).then(finish, finish);
          function finish() { btn.removeAttribute('aria-busy'); set({ rsvp: true }); }
        });
        node = el('div', { class: 'ojx-mod ojx-mod--narrow' }, d.rsvpRows.map(function (r) {
          return el('div', { class: 'ojx-kv' }, [el('span', { class: 'ojx-kv__k', text: r.label }), el('span', { class: 'ojx-kv__v', text: r.value })]);
        }).concat([done, action]));
        update = function () { done.hidden = !state.rsvp; action.hidden = !interactive || state.rsvp; };
      } else if (d.module === 'rows' && d.rows) {
        node = el('div', { class: 'ojx-mod ojx-mod--narrow ojx-mod--rows' }, d.rows.map(function (r) {
          return el('div', { class: 'ojx-row' }, [el('span', { class: 'ojx-row__name', text: r.name }), el('span', { class: 'ojx-row__detail' + (r.accent ? ' is-accent' : ''), text: r.detail })]);
        }).concat([d.note ? el('p', { class: 'ojx-mod__note ojx-mod__note--below', text: d.note }) : null]));
      } else if (d.module === 'ballot') {
        var bdone = el('p', { class: 'ojx-mod__done', role: 'status', hidden: true, text: d.ballotDone || 'You’re in the ballot.' });
        var bbtn = el('button', { type: 'button', class: 'ojx-btn2', text: d.ballotLabel || 'Enter the ballot' });
        var baction = el('div', { class: 'ojx-mod__action', hidden: !interactive }, [bbtn]);
        bbtn.addEventListener('click', function () {
          bbtn.setAttribute('aria-busy', 'true');
          services.ballot(day.n).then(finish, finish);
          function finish() { bbtn.removeAttribute('aria-busy'); set({ ballot: true }); }
        });
        node = el('div', { class: 'ojx-mod ojx-mod--narrow' }, [d.ballotNote ? el('p', { class: 'ojx-mod__text', text: d.ballotNote }) : null, bdone, baction]);
        update = function () { bdone.hidden = !state.ballot; baction.hidden = !interactive || state.ballot; };
      }
      if (!node) return null;
      var inst = { node: node, update: update };
      modules.push(inst);
      update();
      return inst;
    }
    var copyTimer;
    function copyCode(code) {
      services.copyCode(code);
      set({ copied: code });
      clearTimeout(copyTimer);
      copyTimer = setTimeout(function () { if (state.copied === code) set({ copied: '' }); }, COPIED_MS);
    }

    /* ---------- render ---------- */
    function render() {
      renderHero(); renderSignup(); renderDoors(); renderStars(); renderPanel(); renderModal(); renderPreview();
      modules.forEach(function (m) { m.update(); });
      modules = modules.filter(function (m) { return root.contains(m.node); });
    }

    function renderHero() {
      if (!heroCta) return;
      heroCta.hidden = today.phase === 'post';
      heroLabel.textContent = today.phase === 'pre' ? 'See The Eight Doors' : 'Open Today’s Door';
    }

    function renderSignup() {
      if (!signup) return;
      var post = today.phase === 'post';
      var textBlock = signup.querySelector('.ojx-signup__text');
      if (textBlock) textBlock.hidden = post;
      signupInput.hidden = post || state.subscribed;
      signupBtn.hidden = post || state.subscribed;
      signupDone.hidden = post || !state.subscribed;
      signupClosed.hidden = !post;
      if (post || state.subscribed) { signupError.hidden = true; signup.classList.remove('is-invalid'); }
    }

    function renderDoors() {
      days.forEach(function (day) {
        var open = isOpen(day);
        var cell = $('[data-ojx-cell="' + day.n + '"]'), door = $('[data-ojx-door="' + day.n + '"]'), row = $('[data-ojx-lrow="' + day.n + '"]');
        [cell, door, row].forEach(function (node) {
          if (!node) return;
          node.classList.toggle('is-past', day.isPast);
          node.classList.toggle('is-today', day.isToday);
          node.classList.toggle('is-future', day.isFuture);
          node.classList.toggle('is-open', open);
          node.classList.toggle('is-opening', day.isToday && state.doorOpening);
        });
        [door, row].forEach(function (node) {
          if (!node) return;
          node.setAttribute('aria-label', labelFor(day));
          if (day.isToday || day.isPast) node.setAttribute('aria-pressed', (open || day.isPast) ? 'true' : 'false');
          else node.removeAttribute('aria-pressed');
        });
        if (cell) {
          $('[data-ojx-caption-title]', cell).textContent = day.isFuture ? '' : day.d.title;
          $('[data-ojx-caption-meta]', cell).textContent = metaFor(day);
          var tap = $('[data-ojx-tap]', cell); if (tap) tap.hidden = !(day.isToday && !open);
          var reveal = $('[data-ojx-reveal]', cell); if (reveal) reveal.alt = '';
        }
        if (row) {
          $('[data-ojx-lrow-title]', row).textContent = day.isFuture ? '' : day.d.title;
          $('[data-ojx-lrow-meta]', row).textContent = metaFor(day);
        }
      });
      if (grid) grid.hidden = state.layout !== 'grid';
      if (list) list.hidden = state.layout !== 'list';
      $$('[data-ojx-view]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-ojx-view') === state.layout ? 'true' : 'false'); });
    }

    function renderStars() {
      if (!stars) return;
      var count = Clock.progressCount(today, state.doorOpened, TOTAL);
      $$('[data-ojx-star]', stars).forEach(function (svg, i) { svg.classList.toggle('is-filled', i < count); });
      stars.setAttribute('aria-label', count + ' of ' + TOTAL + ' doors opened');
    }

    var panelDayRendered = null, panelTimer = null;
    function renderPanel() {
      if (!panel) return;
      var day = todayDay();
      if (!day) { panel.hidden = true; panel.classList.remove('is-open'); pdoor.classList.remove('is-open'); panelDayRendered = null; return; }
      panel.hidden = false;
      if (panelDayRendered !== day.n) {
        panelDayRendered = day.n;
        var reveal = $('[data-ojx-pdoor-reveal]', pdoor);
        reveal.loading = 'eager'; reveal.src = day.imgs.img640; reveal.alt = day.d.title;
        $$('[data-ojx-pdoor-leaf]', pdoor).forEach(function (img) { img.loading = 'eager'; img.src = day.kit.leaf; });
        $('[data-ojx-pdoor-tag]', pdoor).textContent = day.d.tag;
        panelCopy.innerHTML = '';
        var mod = buildModule(day, true, false);
        [
          el('div', { class: 'ojx-today__meta' }, [el('span', { class: 'ojx-today__eyebrow', text: 'Day ' + day.n2 + ' · ' + day.cal.dowLong + ' ' + day.cal.date }), el('span', { class: 'ojx-pill', text: 'Open Today' })]),
          el('h2', { class: 'ojx-today__title', text: day.d.title }),
          el('p', { class: 'ojx-today__lede', text: day.d.lede }),
          el('p', { class: 'ojx-today__body', text: day.d.body }),
          mod ? mod.node : null,
          el('div', { class: 'ojx-today__cta' }, [el('a', { class: 'ojx-btn', href: link(day.d.url) }, [el('span', { text: day.d.cta })])])
        ].forEach(function (n) { if (n) panelCopy.appendChild(n); });
      }
      panel.classList.toggle('is-open', state.todayOpen);
      clearTimeout(panelTimer);
      if (state.todayOpen) {
        /* Leaves stay shut until the panel has finished expanding, then swing. */
        panelTimer = setTimeout(function () {
          pdoor.classList.add('is-open');
          if (!state.doorOpened) markOpened();
        }, reduce ? 0 : PANEL_MS);
      } else {
        pdoor.classList.remove('is-open');
      }
    }
    function markOpened() {
      if (today.index) session.setItem('ojx:opened:' + today.index, '1');
      analytics('Eight Days of Christmas Door Opened', { day: today.index });
      set({ doorOpened: true, doorOpening: false });
    }

    /* ---------- modal ---------- */
    var opener = null, modalDayRendered = null, lastFocus = null;
    function renderModal() {
      if (!modal) return;
      var open = state.modalIndex !== null;
      if (!open) {
        if (!modal.hidden) {
          modal.hidden = true; modalDayRendered = null; modalBody.innerHTML = ''; modalMedia.innerHTML = '';
          document.documentElement.style.overflow = '';
          if (opener && typeof opener.focus === 'function') opener.focus();
          if (snow) snow.resume();
        }
        return;
      }
      var idx = Math.max(0, Math.min(TOTAL - 1, state.modalIndex));
      var day = days[idx];
      if (modalDayRendered !== idx) {
        modalDayRendered = idx;
        renderModalContent(day);
      }
      modalPrev.disabled = idx === 0;
      modalNext.disabled = idx === TOTAL - 1;
      prevLabel.textContent = idx === 0 ? 'Previous' : (days[idx - 1].isFuture ? 'Previous' : days[idx - 1].d.title);
      nextLabel.textContent = idx === TOTAL - 1 ? 'Next' : (days[idx + 1].isFuture ? 'Tomorrow’s Door' : 'Next');
      modalCounter.textContent = 'Day ' + day.n + ' of ' + TOTAL;
      if (modal.hidden) {
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        if (snow) snow.pause();
        setTimeout(function () { modalCard.focus(); }, 30);
      }
    }
    function renderModalContent(day) {
      var d = day.d, open = isOpen(day);
      modalMedia.innerHTML = '';
      var imgSrc = (cfg.modalUsesAltImage && day.imgs.alt800) ? day.imgs.alt800 : day.imgs.img640;
      modalMedia.appendChild(el('img', { class: 'ojx-modal__img', src: imgSrc, alt: day.isFuture ? '' : d.title, loading: 'eager', decoding: 'async' }));
      if (day.isFuture) modalMedia.appendChild(el('div', { class: 'ojx-modal__locked' }, [el('span', { class: 'ojx-modal__locked-num', text: day.n2 }), el('span', { class: 'ojx-modal__locked-when', text: 'Opens ' + day.cal.dowLong })]));
      else if (day.isPast) modalMedia.appendChild(el('span', { class: 'ojx-badge ojx-badge--brown', text: 'Closed' }));
      else modalMedia.appendChild(el('span', { class: 'ojx-badge', text: 'Open Today' }));

      modalBody.innerHTML = '';
      var eyebrow = day.isFuture ? 'Day ' + day.n2 + ' · Opens ' + day.cal.dowLong : 'Day ' + day.n2 + ' · ' + day.cal.dowLong + ' ' + day.cal.date + ' · ' + d.tag;
      modalBody.appendChild(el('p', { class: 'ojx-modal__eyebrow', text: eyebrow }));
      if (day.isFuture) {
        modalBody.appendChild(el('h2', { class: 'ojx-modal__title', id: 'ojx-modal-title', text: 'A door yet to open' }));
        modalBody.appendChild(el('p', { class: 'ojx-modal__future', text: 'This door opens ' + day.cal.dowLong + ' morning at 8am.' }));
        modalBody.appendChild(el('div', { class: 'ojx-modal__foot' }, [buildNotify(day)]));
        return;
      }
      modalBody.appendChild(el('h2', { class: 'ojx-modal__title', id: 'ojx-modal-title', text: d.title }));
      modalBody.appendChild(el('div', { class: 'ojx-modal__lede' }, [day.icon ? el('img', { class: 'ojx-modal__icon', src: day.icon, alt: '', 'aria-hidden': 'true', loading: 'lazy', decoding: 'async' }) : null, el('p', { text: d.lede })]));
      modalBody.appendChild(el('p', { class: 'ojx-modal__text', text: d.body }));
      var mod = buildModule(day, day.isToday, true);
      if (mod) modalBody.appendChild(mod.node);
      var cta = el('a', { class: 'ojx-btn ojx-btn--full' + (day.isPast ? ' ojx-btn--outline' : ''), href: link(d.url) }, [el('span', { text: d.cta }), day.isPast ? arrow() : null]);
      modalBody.appendChild(el('div', { class: 'ojx-modal__foot' }, [cta]));
      void open;
    }
    function buildNotify(day) {
      var notified = state.notified.indexOf(day.idx) >= 0;
      if (notified) return el('p', { class: 'ojx-notify__done', role: 'status', text: 'We’ll write to you on ' + day.cal.dowLong + '.' });
      var input = el('input', { class: 'ojx-notify__input', type: 'email', name: 'email', autocomplete: 'email', inputmode: 'email', placeholder: 'you@address.com', 'aria-label': 'Email address', value: email || '' });
      var btn = el('button', { type: 'submit', class: 'ojx-notify__btn', text: 'Notify Me' });
      var error = el('p', { class: 'ojx-notify__error', role: 'alert', hidden: true, text: 'Please check your email address.' });
      var form = el('form', { class: 'ojx-notify', novalidate: true }, [input, btn]);
      var wrap = el('div', {}, [form, error]);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var address = (input.value || '').trim();
        if (!EMAIL_RE.test(address)) { form.classList.add('is-invalid'); error.textContent = 'Please check your email address.'; error.hidden = false; input.focus(); return; }
        form.classList.remove('is-invalid'); error.hidden = true;
        btn.disabled = true; btn.textContent = 'One moment…';
        services.notify(address, day.n).then(function () {
          var next = state.notified.slice(); if (next.indexOf(day.idx) < 0) next.push(day.idx);
          session.setItem('ojx:notified', JSON.stringify(next));
          modalDayRendered = null;
          set({ notified: next });
        }, function () {
          btn.disabled = false; btn.textContent = 'Notify Me';
          error.textContent = 'Please try again in a moment.'; error.hidden = false;
        });
      });
      return wrap;
    }
    function focusables() {
      return $$('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])', modalCard).filter(function (n) { return !n.hidden && n.offsetParent !== null; });
    }
    function firstFocusable() { return focusables()[0] || null; }
    function openModal(idx, from) { opener = from || document.activeElement; set({ modalIndex: idx }); }
    function closeModal() { if (state.modalIndex !== null) set({ modalIndex: null }); }

    /* ---------- preview switcher ---------- */
    function renderPreview() {
      if (!preview) return;
      if (!today.preview) { preview.hidden = true; return; }
      preview.hidden = false;
      /* Sit above Shopify's theme preview bar when it is present. */
      preview.style.bottom = document.querySelector('#preview-bar-iframe, #PBarNextFrameWrapper, .shopify-preview-bar') ? '76px' : '';
      if (!preview.childNodes.length) {
        var tokens = [];
        for (var i = 1; i <= TOTAL; i++) tokens.push({ t: String(i), label: String(i) });
        tokens.push({ t: 'pre', label: 'Pre' }, { t: 'post', label: 'Post' }, { t: 'live', label: 'Live' });
        preview.appendChild(el('span', { class: 'ojx-preview__label', text: 'Preview' }));
        tokens.forEach(function (tok) {
          var b = el('button', { type: 'button', class: 'ojx-preview__btn', text: tok.label, 'data-ojx-preview-token': tok.t, 'aria-pressed': 'false' });
          b.addEventListener('click', function () { switchDay(tok.t); });
          preview.appendChild(b);
        });
      }
      $$('[data-ojx-preview-token]', preview).forEach(function (b) {
        var t = b.getAttribute('data-ojx-preview-token'), on;
        if (t === 'live') on = today.source === 'live';
        else if (t === 'pre' || t === 'post') on = today.source !== 'live' && today.phase === t;
        else on = today.source !== 'live' && today.phase === 'live' && String(today.index) === t;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function switchDay(token) {
      Clock.setPreviewDay(session, token, TOTAL);
      try {
        var url = new URL(location.href);
        if (url.searchParams.has('day')) { url.searchParams.delete('day'); history.replaceState(null, '', url.pathname + (url.search || '') + url.hash); }
      } catch (e) {}
      today = resolve('');
      state = Clock.resetForDaySwitch(state);
      restoreOpened();
      panelDayRendered = null; modalDayRendered = null; modules = [];
      pdoor.classList.remove('is-open');
      buildDays();
      document.documentElement.style.overflow = '';
      render();
    }

    /* ---------- interactions ---------- */
    function headerOffset() {
      var hdr = document.querySelector('nav.main-header-nav, .shopify-section-header [class*="header"]');
      if (!hdr) return 0;
      var pos = getComputedStyle(hdr).position;
      return (pos === 'fixed' || pos === 'sticky') ? hdr.getBoundingClientRect().height : 0;
    }
    var openTimer;
    function openToday() {
      if (!panel || panel.hidden) return;
      if (state.todayOpen) return;
      var target = panel.getBoundingClientRect().top + window.pageYOffset - 24 - headerOffset();
      var dist = Math.abs(target - window.pageYOffset);
      window.scrollTo({ top: target, behavior: reduce ? 'auto' : 'smooth' });
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { set({ todayOpen: true }); }, reduce ? 0 : Math.min(700, 250 + dist * 0.35));
    }
    if (heroCta) heroCta.addEventListener('click', function () {
      if (today.phase === 'pre') { var doors = $('[data-ojx-doors]'); if (doors) doors.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); return; }
      openToday();
    });
    var closeBtn = $('[data-ojx-today-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { set({ todayOpen: false }); });

    function onDoor(day, from) {
      if (!day.isToday || state.doorOpened) { openModal(day.idx, from); return; }
      if (state.doorOpening) return;
      if (reduce) { session.setItem('ojx:opened:' + today.index, '1'); opener = from; analytics('Eight Days of Christmas Door Opened', { day: today.index }); set({ doorOpened: true, modalIndex: day.idx }); return; }
      opener = from;
      set({ doorOpening: true });
      setTimeout(function () {
        session.setItem('ojx:opened:' + today.index, '1');
        analytics('Eight Days of Christmas Door Opened', { day: today.index });
        set({ doorOpened: true, doorOpening: false, modalIndex: day.idx });
      }, HINGE_MS);
    }
    $$('[data-ojx-door], [data-ojx-lrow]').forEach(function (node) {
      var n = parseInt(node.getAttribute('data-ojx-door') || node.getAttribute('data-ojx-lrow'), 10);
      node.addEventListener('click', function () { onDoor(days[n - 1], node); });
    });
    $$('[data-ojx-view]').forEach(function (b) {
      b.addEventListener('click', function () {
        var layout = b.getAttribute('data-ojx-view') === 'list' ? 'list' : 'grid';
        local.setItem('ojx:layout', layout);
        set({ layout: layout });
      });
    });

    if (signup) signup.addEventListener('submit', function (e) {
      e.preventDefault();
      if (state.subscribed || today.phase === 'post') return;
      var address = (signupInput.value || '').trim();
      if (!EMAIL_RE.test(address)) { signup.classList.add('is-invalid'); signupError.textContent = 'Please check your email address.'; signupError.hidden = false; signupInput.focus(); return; }
      signup.classList.remove('is-invalid'); signupError.hidden = true;
      signupBtn.disabled = true; signupBtn.textContent = 'One moment…';
      services.subscribe(address).then(function () {
        session.setItem('ojx:subscribed', '1');
        signupBtn.disabled = false; signupBtn.textContent = 'Notify Me';
        set({ subscribed: true });
      }, function () {
        signupBtn.disabled = false; signupBtn.textContent = 'Notify Me';
        signupError.textContent = 'Please try again in a moment.'; signupError.hidden = false;
      });
    });
    if (signupInput) signupInput.addEventListener('input', function () { if (!signupError.hidden) { signupError.hidden = true; signup.classList.remove('is-invalid'); } });

    if (modal) {
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      $('[data-ojx-modal-close]').addEventListener('click', closeModal);
      modalPrev.addEventListener('click', function (e) { e.stopPropagation(); if (state.modalIndex > 0) set({ modalIndex: state.modalIndex - 1 }); });
      modalNext.addEventListener('click', function (e) { e.stopPropagation(); if (state.modalIndex < TOTAL - 1) set({ modalIndex: state.modalIndex + 1 }); });
      modalCard.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var f = focusables(); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === modalCard)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }
    document.addEventListener('keydown', function (e) {
      if (state.modalIndex === null) return;
      if (e.key === 'Escape') { e.preventDefault(); closeModal(); }
      else if (e.key === 'ArrowLeft' && state.modalIndex > 0) set({ modalIndex: state.modalIndex - 1 });
      else if (e.key === 'ArrowRight' && state.modalIndex < TOTAL - 1) set({ modalIndex: state.modalIndex + 1 });
    });

    /* Re-check the clock when the tab comes back (a door may have opened at 08:00 meanwhile). */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden || today.source !== 'live') return;
      var fresh = resolve('');
      if (fresh.phase !== today.phase || fresh.index !== today.index) switchDay('live');
    });

    /* ---------- snow ---------- */
    var snow = startSnow($('[data-ojx-snow]'));
    function startSnow(canvas) {
      if (!canvas || reduce) return null;
      var ctx = canvas.getContext('2d'); if (!ctx) return null;
      var W = 0, H = 0, flakes = [], sprites = {}, raf = null, paused = false, hidden = false;
      function sprite(r) {
        var key = Math.round(r * 4);
        if (sprites[key]) return sprites[key];
        var pad = Math.ceil(r * 2.5) + 2, size = Math.ceil(r * 2 + pad * 2);
        var c = document.createElement('canvas'); c.width = c.height = size;
        var x = c.getContext('2d');
        x.shadowColor = 'rgba(78,54,41,.18)'; x.shadowBlur = r * 2.5; x.fillStyle = '#FFFFFF';
        x.beginPath(); x.arc(size / 2, size / 2, r, 0, Math.PI * 2); x.fill();
        sprites[key] = { c: c, half: size / 2 };
        return sprites[key];
      }
      function resize() {
        W = canvas.width = window.innerWidth; H = canvas.height = window.innerHeight;
        var n = Math.min(90, Math.round(60 + (W / 1400) * 30));
        flakes = [];
        for (var i = 0; i < n; i++) {
          var r = 1.8 + Math.random() * 2.4;
          flakes.push({ x: Math.random() * W, y: Math.random() * H, r: r, v: .25 + Math.random() * .55, p: Math.random() * Math.PI * 2, s: .15 + Math.random() * .35, a: .55 + Math.random() * .35, sp: sprite(r) });
        }
      }
      function tick() {
        raf = null;
        if (hidden) return;
        ctx.clearRect(0, 0, W, H);
        if (!paused) {
          for (var i = 0; i < flakes.length; i++) {
            var f = flakes[i];
            f.p += .006; f.y += f.v; f.x += Math.sin(f.p) * f.s;
            if (f.y > H + 6) { f.y = -6; f.x = Math.random() * W; }
            if (f.x < -6) f.x = W + 6; else if (f.x > W + 6) f.x = -6;
            ctx.globalAlpha = f.a;
            ctx.drawImage(f.sp.c, f.x - f.sp.half, f.y - f.sp.half);
          }
          ctx.globalAlpha = 1;
        }
        raf = requestAnimationFrame(tick);
      }
      var resizeTimer;
      window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(resize, 150); });
      document.addEventListener('visibilitychange', function () { hidden = document.hidden; if (!hidden && !raf) raf = requestAnimationFrame(tick); });
      resize();
      raf = requestAnimationFrame(tick);
      return { pause: function () { paused = true; }, resume: function () { paused = false; } };
    }

    /* ---------- go ---------- */
    buildDays();
    render();
    root.classList.add('is-ready');
    /* Deep link: #open scrolls straight to today's door. */
    if (location.hash === '#open' && today.index) setTimeout(openToday, 300);
  }
})();
